import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  widgetData: undefined,
  jobOrders: null,
  agencies: [],
  corporationsAgencySupport: [],
  corporationsAgencySupportCount: 0,
  isCorporationsAgencySupportLoading: false,
  agencyDetail: {},
  isAgencyLoading: false,
  agencyTotalCount: 0,
  isWidgetDataLoading: false,
  isJobOrdersLoading: false,
  isAgenciesLoading: false,
  isUpdatingAgency: false,
  isCreatingAgency: false,
  widgetError: null,
};

export const dashboardSlice = createSlice({
  name: 'dashboardSlice',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    getWidgetData: (state) => {
      state.isWidgetDataLoading = true;
      state.widgetError = null;
    },
    getWidgetDataProcessed: (state, action) => {
      state.isWidgetDataLoading = false;
      state.widgetData = action.payload.data ?? null;
    },
    getWidgetDataError: (state, action) => {
      state.isWidgetDataLoading = false;
      state.widgetError = action.payload;
    },
    getJobOrdersForDashboard: (state) => {
      state.isJobOrdersLoading = true;
    },
    getJobOrdersForDashboardProcessed: (state, action) => {
      state.isJobOrdersLoading = false;
      state.jobOrders = action.payload.data;
    },
    getJobOrdersForDashboardError: (state) => {
      state.isJobOrdersLoading = false;
      state.jobOrders = initialState.jobOrders;
    },
    getAgenciesForDashboard: (state, action) => {
      if (action?.payload?.page === 0) {
        state.agencies = initialState.agencies;
      }
      state.isAgenciesLoading = true;
    },
    getAgenciesForDashboardProcessed: (state, action) => {
      state.isAgenciesLoading = false;
      state.agencies = [...state.agencies, ...action.payload.data.documents];
      state.agencyTotalCount = action.payload.data.count;
    },
    getAgenciesForDashboardError: (state) => {
      state.isAgenciesLoading = false;
    },
    getAgencyForAgencyDetail: (state) => {
      state.isAgencyLoading = true;
    },
    getAgencyForAgencyDetailProcessed: (state, action) => {
      state.isAgencyLoading = false;
      state.agencyDetail = action.payload.data.documents.at(0);
    },
    getAgencyForAgencyDetailError: (state) => {
      state.isAgencyLoading = false;
    },
    createAgency: (state) => {
      state.isCreatingAgency = true;
    },
    createAgencyProcessed: (state) => {
      state.isCreatingAgency = false;
    },
    createAgencyError: (state) => {
      state.isCreatingAgency = false;
    },
    updateAgencyAddress: (state) => {
      state.isUpdatingAgency = true;
    },
    updateAgencyAddressProcessed: (state, action) => {
      state.isUpdatingAgency = false;
      state.agencyDetail = action?.payload?.data?.documents?.[0];
    },
    updateAgencyAddressError: (state) => {
      state.isUpdatingAgency = false;
    },
    updateAgencyIndustries: (state) => {
      state.isUpdatingAgency = true;
    },
    updateAgencyIndustriesProcessed: (state, action) => {
      state.isUpdatingAgency = false;
      state.agencyDetail = action?.payload?.data?.documents?.[0];
    },
    updateAgencyIndustriesError: (state) => {
      state.isUpdatingAgency = false;
    },
    getCorporationsAgencySupport: (state, action) => {
      state.isCorporationsAgencySupportLoading = true;
      if (action?.payload?.page === 0) {
        state.corporationsAgencySupport = initialState.corporationsAgencySupport;
      }
    },
    getCorporationsAgencySupportProcessed: (state, action) => {
      state.isCorporationsAgencySupportLoading = false;
      const documents = action?.payload?.data?.documents || [];
      state.corporationsAgencySupport = [...state.corporationsAgencySupport, ...documents];
      state.corporationsAgencySupportCount = action?.payload?.data?.count;
    },
    getCorporationsAgencySupportError: (state) => {
      state.isCorporationsAgencySupportLoading = false;
    },
  },
});

export const dashboardReducer = dashboardSlice.reducer;

export const {
  getWidgetData,
  getWidgetDataError,
  getWidgetDataProcessed,
  getJobOrdersForDashboard,
  getJobOrdersForDashboardProcessed,
  getJobOrdersForDashboardError,
  getAgenciesForDashboard,
  getAgenciesForDashboardProcessed,
  getAgenciesForDashboardError,
  getAgencyForAgencyDetail,
  getAgencyForAgencyDetailProcessed,
  getAgencyForAgencyDetailError,
  createAgency,
  createAgencyProcessed,
  createAgencyError,
  updateAgencyAddress,
  updateAgencyAddressProcessed,
  updateAgencyAddressError,
  updateAgencyIndustries,
  updateAgencyIndustriesProcessed,
  updateAgencyIndustriesError,
  getCorporationsAgencySupport,
  getCorporationsAgencySupportProcessed,
  getCorporationsAgencySupportError,
} = dashboardSlice.actions;
